module.exports = __webpack_public_path__ + "media/images/emblems/Flurlingen-blazon-bec8ddab8ebf755f9a70c33085d424f2.svg";